// extracted by mini-css-extract-plugin
export default {"BackButton":"ParentCompanyDetailPage_BackButton__FcPc8"};